Revolution.Module.extend({
    NAME: "mde.you-are", // OBLIGATOIRE (reflète l'arborescence répertoire : /mde/you-are.js)

    initialize: function ($) {
        // appelé aussitôt la page chargée
        //console.log("module " + this.NAME);

        //_.bindAll(this, "equalheight", "runEqualHeight", "getHeightsForOffsets");

        //events


        this.initchoices()
    },

    onWindowLoad: function (e) {

    },

    onWindowScroll: function (e) {

    },

    onWindowResize: function (e) {

    },

    initchoices: function () {
        if ($('.js-you-are-choice').length) {
            var activeOption = $('.js-you-are-choice.active');
            $('.js-you-are-options[data-name="'+activeOption.data('target')+'"]').fadeIn().addClass('displayed');

            $('.js-you-are-choice').on('click', function() {
                if ($(this).hasClass('active')) { return; }

                $('.js-you-are-choice.active').removeClass('active').attr('aria-expanded', 'false');
                $(this).addClass('active').attr('aria-expanded', 'true');

                $('.js-you-are-options.displayed').fadeOut().removeClass('displayed');
                $('.js-you-are-options[data-name="'+$(this).data('target')+'"]').fadeIn().addClass('displayed');
            });
        }
    }

});
